var React = require('react');

function InfoRedirect (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.8909 10.9636L7.63636 15.2182L3.38182 10.9636L4.52727 9.81818L6.81818 12.1091V6.54545H8.45455V12.1091L10.7455 9.81818L11.8909 10.9636ZM5.4 21.6818H9.87273V20.5909H5.4V21.6818ZM0 24V0H15.2727V24H0ZM1.63636 19.9091V22.3636H13.6364V19.9091H1.63636ZM1.63636 18.2727H13.6364V4.09091H1.63636V18.2727ZM1.63636 2.45455H13.6364V1.63636H1.63636V2.45455Z","fill":"black"}));
}

InfoRedirect.defaultProps = {"width":"16","height":"24","viewBox":"0 0 16 24","fill":"none"};

module.exports = InfoRedirect;

InfoRedirect.default = InfoRedirect;
